import { ComponentProps, ComponentType, FunctionComponent } from 'react';
import createConnect, { WithLuvProps } from './withLuv.state';
import { WithLuvAwareProps } from './types';

export const withLuv = <TProps extends WithLuvAwareProps>(
  Component: ComponentType<TProps>,
) => {
  const connect = createConnect<TProps>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = connect(Component as any);

  WrappedComponent.displayName = `WithLuv(${WrappedComponent.displayName ||
    'Component'})`;

  return WrappedComponent as FunctionComponent<
    WithLuvAwareProps & Omit<ComponentProps<typeof Component>, keyof WithLuvProps>
  >;
};
